import ProtectedRoute from "../components/Common/ProtectedRoute";
import EtpLayout from "../layouts/etp-layout";
import HomePageEtp from "../pages/Etp/home";
import { ReportingLayoutEtp } from "../layouts/etp/reporting-layout-etp";
import FolderDetailEtp from "../pages/Etp/folder/detailEtp";
import LearnerReportingEtp from "../pages/Etp/reporting/LearnerEtp";
import CustomerReportingEtp from "../pages/Etp/reporting/CustomerReportingEtp";
import CourseReportingEtp from "../pages/Etp/reporting/ProjectReportinEtp";
import LearnerListEtp from "../pages/Etp/learner/LearnerListEtp";
import FormationReportEtp from "../pages/Etp/reporting/index";
import ReportingRevenue from "../pages/Etp/reporting/RevenueByProjectEtp";
import { FolderEtp } from "../pages/Etp/photo/folder-etp";
import { ProjectEtp } from "../pages/Etp/photo/project-etp";
import { CrudImageEtp } from "../pages/Etp/photo/crud-image-etp";
import Batch from "../pages/Etp/learner/Batch/Batch";
import LayoutCalendarEtp from "../layouts/etp/LayoutCalendarEtp";
import AnnuelCalendarEtp from "../pages/Etp/agenda/annuels/AnnuelCalendarEtp";
import ExcelImport from "../pages/Etp/learner/ExcelImport";
import LearnerLayoutEtp from "../layouts/etp/learner-layout-etp";
import { AuthCalendarProvider } from "../contexts/AuthCalendarProvider";
import { FolderLayout } from "../layouts/cfp/folder-layout";
import FolderListEtp from "../pages/Etp/folder/DossierListEtp";
import Centres from "../pages/Centres";
import Formations from "../pages/Formations";
import Course from "../pages/Course";
import { PhotoContent } from "../contents/photoContent";
import { Navigate } from "react-router-dom";
import EtpProjectList from "../pages/Etp/skill_matrix/EtpProjectList";
import EtpSkills from "../pages/Etp/skill_matrix/EtpSkills";
import SkillEtpContent from "../contents/skillEtp-content";
import { ReferentContent } from "../contents/referent-content";
import { ListeReferentEtp } from "../pages/Etp/referent/liste-referent-etp";
import RewardsEtp from "../pages/Etp/loyalty/RewardsEtp";
import LoyaltyRewardsLayout from "../layouts/cfp/loyalty_rewards-layout";
import { AttendanceContent } from "../contents/attendance-content";
import { AttendanceProjectEtp } from "../pages/Etp/attendance/project-attendance-etp";
import DashboardEntreprise from "../pages/Etp/analytic/DashboardEntreprise";
import AnalyticEtpContent from "../contents/analyticEtp-content";
import CustomerContent from "../contents/customer-content";
import EtpCustomer from "../pages/Etp/customer/etp-customer";
import EtpProjet from "../pages/Etp/projet/projetEtp";
import EtpDetailProjet from "../pages/Etp/projet/detail";
import { SearchProviderProject } from "../contexts/cfp/SearchContextProject";
import ReservationLayout from "../layouts/cfp/reservation-layout";
import ReservationEtp from "../pages/Etp/reservation";
import EvaluationsFroidsEtp from "../pages/Etp/evaluationFroid";
import ProfilEtp from "../pages/Etp/Profil";
import { ProjectFinished } from "../pages/Etp/projet/finished";
import { ProjectPlanned } from "../pages/Etp/projet/planned";
import { ProjectInProgress } from "../pages/Etp/projet/In-progess";
import { ProjectFenced } from "../pages/Etp/projet/fenced";
import { ProjectInPreparation } from "../pages/Etp/projet/in-preparation";
import { ProjectDeferred } from "../pages/Etp/projet/deferred";
import { ProjectCanceld } from "../pages/Etp/projet/canceled";
import Help from "../pages/Etp/help";
import EvaluationChaud from "../pages/Etp/evaluationChaud";
import FmfpIndexEtp from "../pages/Etp/Fmfp";
import FmfpEtpLayout from "../layouts/etp/fmfp-etp-layout";
import { ListeBonCommandeEtp } from "../pages/Etp/bon_commande";

const etpRoutes = {
  path: "/etp",
  element: (
    <ProtectedRoute allowedUserTypes={["superAdminEtp", "adminEtp"]}>
      <EtpLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      index: true,
      element: <HomePageEtp />,
    },
    {
      path: "dossier",
      element: <FolderLayout />,
      children: [
        {
          index: true,
          element: <FolderListEtp />,
        },
        {
          path: "detail/:idDossier",
          element: <FolderDetailEtp />,
        },
      ],
    },
    { path: "centre", element: <Centres /> },
    { path: "annuaire", element: <Formations /> },
    { path: "cours", element: <Course /> },
    {
      path: "reporting",
      element: <ReportingLayoutEtp />,
      children: [
        {
          index: true,
          element: <FormationReportEtp />,
        },
        {
          path: "employe",
          element: <LearnerReportingEtp />,
        },
        {
          path: "client",
          element: <CustomerReportingEtp />,
        },
        {
          path: "cours",
          element: <CourseReportingEtp />,
        },
        {
          path: "cout",
          element: <ReportingRevenue />,
        },
      ],
    },

    {
      path: "employe",
      element: <LearnerLayoutEtp />,
      children: [
        {
          index: true,
          element: <LearnerListEtp />,
        },
        {
          path: "batch",
          element: <Batch />,
        },
        {
          path: "excel",
          element: <ExcelImport />,
        },
      ],
    },
    {
      path: "skill_matrix",
      element: <SkillEtpContent />,
      children: [
        {
          index: true,
          element: <Navigate to="projets" />,
        },
        {
          path: "projets",
          element: <EtpProjectList />,
        },
        {
          path: "projets/:idProjet",
          element: <EtpSkills />,
        },
      ],
    },
    {
      path: "photos",
      element: <PhotoContent />,
      children: [
        {
          index: true,
          element: <FolderEtp />,
        },
        {
          path: "projets",
          element: <ProjectEtp />,
        },
        {
          path: "ajout",
          element: <CrudImageEtp />,
        },
      ],
    },
    {
      path: "agenda",
      element: <AuthCalendarProvider />,
      children: [
        {
          element: <LayoutCalendarEtp />,
          children: [
            {
              index: true,
              element: <AnnuelCalendarEtp />,
            },
            {
              path: "annuel",
              element: <AnnuelCalendarEtp />,
            },
          ],
        },
      ],
    },
    {
      path: "utilisateurs",
      element: <ReferentContent />,
      children: [{ index: true, element: <ListeReferentEtp /> }],
    },
    {
      path: "analytic",
      element: <AnalyticEtpContent />,
      children: [{ index: true, element: <DashboardEntreprise /> }],
    },
    {
      path: "client",
      element: <CustomerContent />,
      children: [{ index: true, element: <EtpCustomer /> }],
    },
    {
      path: "loyalty_rewards",
      element: <LoyaltyRewardsLayout />,
      children: [
        {
          index: true,
          element: <Navigate to="list" />,
        },
        {
          path: "list",
          element: <RewardsEtp />,
        },
      ],
    },
    {
      path: "presence",
      element: <AttendanceContent />,
      children: [{ index: true, element: <AttendanceProjectEtp /> }],
    },
    {
      path: "projet",
      element: <SearchProviderProject />,
      children: [
        {
          index: true,
          element: <EtpProjet />,
        },
        { path: "detail/:id", element: <EtpDetailProjet /> },
        { path: "termine", element: <ProjectFinished /> },
        { path: "en_cours", element: <ProjectInProgress /> },
        { path: "preparation", element: <ProjectInPreparation /> },
        { path: "planifie", element: <ProjectPlanned /> },
        { path: "annule", element: <ProjectCanceld /> },
        { path: "cloture", element: <ProjectFenced /> },
        { path: "reporte", element: <ProjectDeferred /> },
      ],
    },
    {
      path: "reservation",
      element: <ReservationLayout />,
      children: [{ index: true, element: <ReservationEtp /> }],
    },
    {
      path: "evaluation/froids",
      element: <EvaluationsFroidsEtp />,
    },
    {
      path: "evaluation_chaud",
      element: <EvaluationChaud />,
    },
    {
      path: "profile",
      element: <ProfilEtp />,
    },
    {
      path: "aide",
      element: <Help />,
    },
    {
      path: "fmfp",
      element: <FmfpEtpLayout />,
      children: [
        {
          index: true,
          element: <Navigate to="en_soumission" />,
        },
        {
          path: "en_soumission",
          element: <FmfpIndexEtp status_name="En soumission" />,
        },
        {
          path: "en_execution",
          element: <FmfpIndexEtp status_name="Exécuté" />,
        },
        {
          path: "cloture",
          element: <FmfpIndexEtp status_name="Cloturé" />,
        },
        {
          path: "refuse",
          element: <FmfpIndexEtp status_name="Refusé" />,
        },
      ],
    },
    {
      path: "bon-commande",
      element: <ListeBonCommandeEtp />,
    },
    // {
    //   path: "bon-commande/view/:id",
    //   element: <BonCommandeView />,
    // },
  ],
};

export default etpRoutes;
